var map = {
	"./amb.png": 6746,
	"./dragon1.png": 2900,
	"./dragon2.png": 1807,
	"./dragon3.png": 2790,
	"./evol.png": 7024,
	"./gclub.png": 5629,
	"./gioco.png": 2163,
	"./jili.png": 4666,
	"./joker.png": 9015,
	"./king.png": 3249,
	"./micro.png": 9962,
	"./pg.png": 2387,
	"./play.png": 258,
	"./prag.png": 4494,
	"./prag1.png": 1573,
	"./sa-gaming.png": 3200,
	"./sbobet1.png": 9078,
	"./sexy.png": 8365,
	"./spade.png": 9941,
	"./ufabet1.png": 634,
	"./wm.png": 752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1534;